import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-32 bg-[color:var(--bg-soft)]/60 border-b hairline"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-y-10 md:gap-x-16">
        <div className="col-span-12 md:col-span-5">
          <div className="section-label mb-4">
            <span className="dot" /> FAQ
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.05] text-balance">
            Questions we get{" "}
            <span className="font-serif-accent italic font-normal">
              every week.
            </span>
          </h2>
          <p className="mt-6 text-[color:var(--ink-2)] max-w-md">
            Don't see your question? Drop it in the contact form and we'll
            answer in plain language within a working day.
          </p>
        </div>

        <div className="col-span-12 md:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b hairline"
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-medium hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[color:var(--ink-2)] text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
